// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__Jp9uZ","active":"tabs_active__4JxqV","dropdown":"tabs_dropdown__ZaIO5","content":"tabs_content__GyVKy"};